import React, { useEffect, useMemo, useRef, useState } from "react";
import { useFormik } from "formik";
import { useHistory, useParams } from "react-router-dom";
import Select from "react-select";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { usePermissionGuardRedirect } from "../../../hooks/usePermissionGuard";
import {
  addHeaderDetails,
  getAccentColorBaseOnBrandTmpList,
  GetAllHeaderPMCpageList,
  getHeaderDetails,
  getHeaderDropDownList,
  getHeadersPageList,
  updateHeaderDetails,
} from "../../../services/LayoutHeaderServices";
import PermissionsGate from "../../../utils/permissionGate";
import { FileUploadField, FormField } from "../../common/FormFields";
import AssignPagePopup from "./AssignPagePopup";
import AssignQualificationPopup from "./AssignQualificationPopup";
import HeaderButtonBlock from "./HeaderButtonBlock";

const sanitiseButtonSubmitFields = (data, isShownField, typeField, assignedField, urlField) => {
  if (data[isShownField] !== 1) {
    delete data[assignedField];
    data[urlField] = "";
    return;
  }

  if (data[typeField] === 2) {
    delete data[assignedField];
  }

  if (data[typeField] === 0 || data[typeField] === 1) {
    data[urlField] = "";
  }
};

const HeaderInformation = ({ setHeaderName }) => {
  const { subId, subTab, type } = useParams();
  const history = useHistory();
  const [headerTypeArr, setHeaderTypeArr] = useState([]);
  const [headerButtonTypeArr, setHeaderButtonTypeArr] = useState([]);
  const [colorArr, setColorArr] = useState([]);
  const [brandData, setBrandData] = useState({});
  const [assignedQualification, setAssignedQualification] = useState({});
  const [assignedPopupPages, setAssignedPopupPages] = useState({});
  const [assignedPopupPages2, setAssignedPopupPages2] = useState({});
  const [assignedQualification2, setAssignedQualification2] = useState({});
  const [assignedPopupPages3, setAssignedPopupPages3] = useState({});
  const [assignedQualification3, setAssignedQualification3] = useState({});
  const [updateData, setUpdateData] = useState(Date.now())
  const [headerData, setHeaderData] = useState([])
  const [headerData2, setHeaderData2] = useState([])
  const [headerData3, setHeaderData3] = useState([])
  const assignedPageRef = useRef(assignedPopupPages);
  const assignedPageRef2 = useRef(assignedPopupPages2);
  const assignedPageRef3 = useRef(assignedPopupPages3);
  const assignedQualificationRef = useRef(assignedQualification);
  const assignedQualificationRef2 = useRef(assignedQualification2);
  const assignedQualificationRef3 = useRef(assignedQualification3);
  const [refresh, setRefresh]=useState(Date.now())

  assignedPageRef.current = assignedPopupPages;
  assignedQualificationRef.current = assignedQualification;
  assignedPageRef2.current = assignedPopupPages2;
  assignedQualificationRef2.current = assignedQualification2;
  assignedPageRef3.current = assignedPopupPages3;
  assignedQualificationRef3.current = assignedQualification3;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getHeaderDropDownList();
        setHeaderTypeArr(res.data.headerType || []);
        setHeaderButtonTypeArr(res.data.headerButtonType || []);
      } catch (error) {
        // if (!axios.isCancel(error)) {
        console.error(error);
        // }
      }
    };

    fetchData();
  }, [refresh]);

  const getAccentColor = async (value) => {
    try {
      let res = await getAccentColorBaseOnBrandTmpList({
        brandID: value ? value : [],
      });
      setColorArr(res?.data?.result || []);
    } catch (error) {
      // if (!axios?.isCancel(error)) {
      console.error(error);
      // }
    }
  };

  const permissionWbslnheadersview = usePermissionGuardRedirect(["wbslnheadersview"]);

  useEffect(() => {
    if (!permissionWbslnheadersview) {
      return;
    }

    const fetchData = async () => {
      try {
        let res = await getHeaderDetails(subId);
        res.data.data.brandTemplete = res.data.data?.brandTemplete?.map(
          (el) => el.BrandID
        );
        getAccentColor([...res.data.data.brandTemplete]);
        setBrandData(res.data?.data);
        setHeaderName(res.data?.data?.SliderName);
        localStorage.setItem("headerName", res.data?.data?.SliderName);
      } catch (error) {
        // if (!axios?.isCancel(error)) {
        if (error.response.data?.message !== "") {
          Swal.fire({
            icon: "Info",
            title: "Info",
            text: "No record found with this id",
          })
          history.push(`/websiteManagement/layout_navigation/header/table`)
        }
        console.error(error);
        // }
      }
    };
    if (((subId && type === "update") || type === "open") && permissionWbslnheadersview) {
      fetchData();
    }
  }, [history, permissionWbslnheadersview, refresh, setHeaderName, subId, type, updateData]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      SliderName: brandData?.SliderName || "",
      IsDefault: brandData?.IsDefault,
      buttonType: brandData?.buttonType,
      buttonText: brandData?.buttonText || "",
      buttonColor: brandData?.buttonColor || "",
      assignedPage: brandData?.assignedPage || {},
      titleHeader: brandData?.titleHeader || "",
      subtitleHeader: brandData?.subtitleHeader || "",
      ItemImgURL: brandData?.ItemImgURL || "",
      ItemVideo: brandData?.ItemVideo || "",
      SliderColor: brandData?.SliderColor || "",
      BackgroundColor: brandData?.BackgroundColor || "",
      headerCID: brandData?.headerCID || "",
      SliderItemID: brandData?.SliderItemID || "",
      LinkURL: brandData?.LinkURL || "",
      contactFormActive: brandData?.contactFormActive || 0,
      isShowVideo: brandData?.isShowVideo || 0,
      isTitleUnderline: brandData?.isTitleUnderline || 0,
      isShowContent: brandData?.isShowContent || 0,
      isShowButton: brandData?.isShowButton || 0,
      isOverrideColor: brandData?.isOverrideColor || 0,

      button2Text: brandData?.button2Text || "",
      button2Type: brandData?.button2Type,
      button2URL: brandData?.button2URL || "",
      isShowButton2: brandData?.isShowButton2 || 0,
      assignedPage2: brandData?.assignedPage2 || {},

      button3Text: brandData?.button3Text || "",
      button3Type: brandData?.button3Type,
      button3URL: brandData?.button3URL || "",
      isShowButton3: brandData?.isShowButton3 || 0,
      assignedPage3: brandData?.assignedPage3 || {},
    },
    validationSchema: Yup.object().shape({
      SliderName: Yup.string().required("Name is required").nullable().trim(),
      IsDefault: Yup.string().required("Header Type is required"),
      buttonType: Yup.mixed().when("isShowButton", {
        is: 1,
        then: Yup.mixed().required("Header Button Type is required"),
      }),
      buttonText: Yup.string().when("isShowButton", {
        is: 1,
        then: Yup.string().required("Header Button Text is required"),
      }),
      assignedPage: Yup.object().when(["isShowButton", "buttonType"], {
        is: (isShow, buttonType) => isShow === 1 && buttonType === 1,
        then: Yup.object().shape({
          id: Yup.mixed().required("Assigned Qualification for Header Button is required"),
          type: Yup.mixed().required("Assigned Qualification Type is required"),
        }),
        otherwise: Yup.object().when(["isShowButton", "buttonType"], {
          is: (isShow, buttonType) => isShow === 1 && buttonType === 0,
          then: Yup.object().shape({
            id: Yup.mixed().required("Assigned Page for Header Button is required"),
            type: Yup.mixed().required("Assigned Page Type is required"),
          }),
          otherwise: Yup.object().nullable(),
        }),
      }),
      titleHeader: Yup.string().required("Header Title Text is required"),
      ItemImgURL: Yup.string().required("Banner Image is required"),
      BackgroundColor: Yup.string().required("Background Colour is required"),
      SliderColor: Yup.string().required("Banner Accent Colour is required"),
      LinkURL: Yup.string().when(["isShowButton", "buttonType"], {
        is: (isShow, buttonType) => isShow === 1 && buttonType === 2,
        then: Yup.string()
          .required("Custom Link is required")
          .matches(/^(\/|https?:\/\/)/, "URL must start with / or a valid protocol"),
      }),
      button2Type: Yup.mixed().when("isShowButton2", {
        is: 1,
        then: Yup.mixed().required("Button 2 Type is required"),
      }),
      button2Text: Yup.string().when("isShowButton2", {
        is: 1,
        then: Yup.string().required("Button 2 Text is required"),
      }),
      assignedPage2: Yup.object().when(["isShowButton2", "button2Type"], {
        is: (isShow, buttonType) => isShow === 1 && buttonType === 1,
        then: Yup.object().shape({
          id: Yup.mixed().required("Assigned Qualification for Button 2 is required"),
          type: Yup.mixed().required("Assigned Qualification Type is required"),
        }),
        otherwise: Yup.object().when(["isShowButton2", "button2Type"], {
          is: (isShow, buttonType) => isShow === 1 && buttonType === 0,
          then: Yup.object().shape({
            id: Yup.mixed().required("Assigned Page for Button 2 is required"),
            type: Yup.mixed().required("Assigned Page Type is required"),
          }),
          otherwise: Yup.object().nullable(),
        }),
      }),
      button2URL: Yup.string().when(["isShowButton2", "button2Type"], {
        is: (isShow, buttonType) => isShow === 1 && buttonType === 2,
        then: Yup.string()
          .required("Custom Link is required")
          .matches(/^(\/|https?:\/\/)/, "URL must start with / or a valid protocol"),
      }),
      button3Type: Yup.mixed().when("isShowButton3", {
        is: 1,
        then: Yup.mixed().required("Button 3 Type is required"),
      }),
      button3Text: Yup.string().when("isShowButton3", {
        is: 1,
        then: Yup.string().required("Button 3 Text is required"),
      }),
      assignedPage3: Yup.object().when(["isShowButton3", "button3Type"], {
        is: (isShow, buttonType) => isShow === 1 && buttonType === 1,
        then: Yup.object().shape({
          id: Yup.mixed().required("Assigned Qualification for Button 3 is required"),
          type: Yup.mixed().required("Assigned Qualification Type is required"),
        }),
        otherwise: Yup.object().when(["isShowButton3", "button3Type"], {
          is: (isShow, buttonType) => isShow === 1 && buttonType === 0,
          then: Yup.object().shape({
            id: Yup.mixed().required("Assigned Page for Button 3 is required"),
            type: Yup.mixed().required("Assigned Page Type is required"),
          }),
          otherwise: Yup.object().nullable(),
        }),
      }),
      button3URL: Yup.string().when(["isShowButton3", "button3Type"], {
        is: (isShow, buttonType) => isShow === 1 && buttonType === 2,
        then: Yup.string()
          .required("Custom Link is required")
          .matches(/^(\/|https?:\/\/)/, "URL must start with / or a valid protocol"),
      }),
    }),
    
    onSubmit: async (values, { setSubmitting }) => {
      let data = { ...values };

      sanitiseButtonSubmitFields(data, "isShowButton", "buttonType", "assignedPage", "LinkURL");
      sanitiseButtonSubmitFields(data, "isShowButton2", "button2Type", "assignedPage2", "button2URL");
      sanitiseButtonSubmitFields(data, "isShowButton3", "button3Type", "assignedPage3", "button3URL");

      const formData = new FormData();

      const cleanedValues = Object.fromEntries(
        Object.entries(data).map(([key, value]) => [
          key,
          value === undefined || value === null ? "" : value
        ])
      );

      const assignedPageKeys = ["assignedPage", "assignedPage2", "assignedPage3"];
      assignedPageKeys.forEach((apKey) => {
        if (cleanedValues[apKey] && typeof cleanedValues[apKey] === 'object') {
          formData.append(`${apKey}[id]`, cleanedValues[apKey].id || "");
          formData.append(`${apKey}[type]`, cleanedValues[apKey].type ?? "");
        }
      });

      Object.keys(cleanedValues).forEach((key) => {
        if (!assignedPageKeys.includes(key)) {
          const value = cleanedValues[key];
          if (Array.isArray(value)) {
            value.forEach((val, idx) => {
              formData.append(`${key}[${idx}]`, val !== undefined && val !== null ? val : "");
            });
          } else {
            formData.append(key, value);
          }
        }
      });

      try {
        if (type === "create") {
          await addHeaderDetails(formData);
          Swal.fire(
            "Success!",
            "Header details created successfully!",
            "success"
          );
          history.push(`/websiteManagement/layout_navigation/header/table`);
        } else if (type === "open") {
          formData.append("SliderID", subId);
          await updateHeaderDetails(formData);
          Swal.fire(
            "Success!",
            "Header details updated successfully!",
            "success"
          );
          formik.resetForm()
          setUpdateData(Date.now())
          history.push(`/websiteManagement/layout_navigation/header/header_information/open/${subId}`);
        }
      } catch (error) {
        Swal.fire(
          "Error!",
          `Failed to ${type === "create" ? "create" : "update"
          } Header details`,
          "error"
        );
        console.log(error);
      }
      setSubmitting(false);
    },
  });
  const checkboxOptions = [
    { name: "contactFormActive", label: "Show Form Block" },
    { name: "isShowVideo", label: "Show Video" },
    { name: "isTitleUnderline", label: "Show Title Underline" },
    { name: "isShowContent", label: "Show Content Text" },
  ];

  const setAssignedFieldValue = (fieldName, assignedTarget = {}) => {
    const resolvedId =
      assignedTarget?.id ??
      assignedTarget?.PageID ??
      assignedTarget?.TrainingCourseLandingPageID ??
      "";

    const resolvedType =
      assignedTarget?.flag ??
      assignedTarget?.type ??
      assignedTarget?.pageType ??
      assignedTarget?.page_type ??
      "";

    formik.setFieldValue(fieldName, {
      id: resolvedId,
      type: resolvedType,
    });
  };

  useEffect(() => {
    if (assignedPopupPages && assignedPopupPages.id) {
      setAssignedFieldValue("assignedPage", assignedPopupPages);
    }
    if (assignedQualification && assignedQualification.id) {
      setAssignedFieldValue("assignedPage", assignedQualification);
    }
    if (assignedPopupPages2 && assignedPopupPages2.id) {
      setAssignedFieldValue("assignedPage2", assignedPopupPages2);
    }
    if (assignedQualification2 && assignedQualification2.id) {
      setAssignedFieldValue("assignedPage2", assignedQualification2);
    }
    if (assignedPopupPages3 && assignedPopupPages3.id) {
      setAssignedFieldValue("assignedPage3", assignedPopupPages3);
    }
    if (assignedQualification3 && assignedQualification3.id) {
      setAssignedFieldValue("assignedPage3", assignedQualification3);
    }
  }, [
    assignedPopupPages,
    assignedQualification,
    assignedPopupPages2,
    assignedQualification2,
    assignedPopupPages3,
    assignedQualification3,
  ]);

  useEffect(() => {
    const fetchButtonAssignmentList = async () => {
      if (!subId) {
        setHeaderData([]);
        setHeaderData2([]);
        setHeaderData3([]);
        return;
      }

      const loadButtonAssignments = (buttonType) => {
        const normalisedButtonType = Number(buttonType);

        if (normalisedButtonType === 0) {
          return getHeadersPageList(subId);
        }
        if (normalisedButtonType === 1) {
          return GetAllHeaderPMCpageList(subId);
        }

        return Promise.resolve(null);
      };

      try {
        const [button1Response, button2Response, button3Response] = await Promise.all([
          loadButtonAssignments(formik.values.buttonType),
          loadButtonAssignments(formik.values.button2Type),
          loadButtonAssignments(formik.values.button3Type),
        ]);

        setHeaderData(button1Response?.data?.data || []);
        setHeaderData2(button2Response?.data?.data || []);
        setHeaderData3(button3Response?.data?.data || []);
      } catch (error) {
        console.log(error);
      }
    };

    fetchButtonAssignmentList();
  }, [formik.values.buttonType, formik.values.button2Type, formik.values.button3Type, subId]);

  useEffect(() => {
    const resetButtonTargetState = (buttonType, urlField, setAssignedQualificationState, setAssignedPageState) => {
      if (buttonType === 2) {
        setAssignedQualificationState({});
        setAssignedPageState({});
        return;
      }

      if (buttonType === 1) {
        setAssignedPageState({});
      } else if (buttonType === 0) {
        setAssignedQualificationState({});
      } else {
        setAssignedQualificationState({});
        setAssignedPageState({});
      }

      formik.setFieldValue(urlField, "");
      formik.setFieldTouched(urlField, false);
    };

    resetButtonTargetState(formik.values.buttonType, "LinkURL", setAssignedQualification, setAssignedPopupPages);
    resetButtonTargetState(formik.values.button2Type, "button2URL", setAssignedQualification2, setAssignedPopupPages2);
    resetButtonTargetState(formik.values.button3Type, "button3URL", setAssignedQualification3, setAssignedPopupPages3);
  }, [formik.values.buttonType, formik.values.button2Type, formik.values.button3Type]);

  useEffect(() => {
    const hydrateAssignedTarget = (buttonType, fieldName, assignedTarget, setAssignedQualificationState, setAssignedPageState) => {
      setAssignedFieldValue(fieldName, assignedTarget);

      if (buttonType === 1) {
        setAssignedQualificationState(assignedTarget || {});
        setAssignedPageState({});
        return;
      }

      if (buttonType === 0) {
        setAssignedPageState(assignedTarget || {});
        setAssignedQualificationState({});
        return;
      }

      setAssignedQualificationState({});
      setAssignedPageState({});
    };

    hydrateAssignedTarget(brandData?.buttonType, "assignedPage", brandData?.assignedPage, setAssignedQualification, setAssignedPopupPages);
    hydrateAssignedTarget(brandData?.button2Type, "assignedPage2", brandData?.assignedPage2, setAssignedQualification2, setAssignedPopupPages2);
    hydrateAssignedTarget(brandData?.button3Type, "assignedPage3", brandData?.assignedPage3, setAssignedQualification3, setAssignedPopupPages3);
  }, [brandData]);

  const buttonConfigs = useMemo(() => [
    {
      idx: 1,
      visibilityField: "isShowButton",
      typeField: "buttonType",
      textField: "buttonText",
      urlField: "LinkURL",
      assignedField: "assignedPage",
      pageModalId: "assignPagePopupBrandTemp",
      qualModalId: "assignQualificationPopup",
      assignedPopupPages,
      setAssignedPopupPages,
      assignedQualification,
      setAssignedQualification,
    },
    {
      idx: 2,
      visibilityField: "isShowButton2",
      typeField: "button2Type",
      textField: "button2Text",
      urlField: "button2URL",
      assignedField: "assignedPage2",
      pageModalId: "assignPagePopupBrandTemp_2",
      qualModalId: "assignQualificationPopup_2",
      assignedPopupPages: assignedPopupPages2,
      setAssignedPopupPages: setAssignedPopupPages2,
      assignedQualification: assignedQualification2,
      setAssignedQualification: setAssignedQualification2,
    },
    {
      idx: 3,
      visibilityField: "isShowButton3",
      typeField: "button3Type",
      textField: "button3Text",
      urlField: "button3URL",
      assignedField: "assignedPage3",
      pageModalId: "assignPagePopupBrandTemp_3",
      qualModalId: "assignQualificationPopup_3",
      assignedPopupPages: assignedPopupPages3,
      setAssignedPopupPages: setAssignedPopupPages3,
      assignedQualification: assignedQualification3,
      setAssignedQualification: setAssignedQualification3,
    },
  ], [
    assignedPopupPages,
    assignedQualification,
    assignedPopupPages2,
    assignedQualification2,
    assignedPopupPages3,
    assignedQualification3,
  ]);

  const getFormikErrorMessage = (error) => {
    if (!error) {
      return null;
    }

    if (typeof error === 'string') {
      return error;
    }

    return error.id || error.type || error.message || "Invalid input";
  };

  return (
    <div className="card card-body-inr">
      <form onSubmit={formik.handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <div className="edit-icon new-card-header">
              <h4 className="card-header">Header Information</h4>
            </div>
          </div>

          <FormField
            field={{ name: "SliderName", label: "Name" }}
            formik={formik}
            placeholder="Enter Name"
          />
          <div className="col-md-6 col-lg-3">
            <div className="form-group-blk mb-3" title="Header Type">
              <label>Header Type * <i className="fal fa-info-circle"></i></label>
              <Select
                className={
                  "form-control custom-select-box" +
                  (formik.errors.IsDefault && formik.touched.IsDefault ? " is-invalid" : "")
                }
                name="IsDefault"
                value={
                  formik.values.IsDefault !== ""
                    ? headerTypeArr.find((val) => val?.value === formik.values.IsDefault)
                    : ""
                }
                onChange={(option) => {
                  formik.setFieldValue("IsDefault", option ? option.value : "");
                }}
                onBlur={formik.handleBlur}
                options={headerTypeArr}
                maxMenuHeight={175}
                placeholder={"Header Type"}
                isClearable
              />

            </div>
          </div>
          <FormField
            field={{ name: "titleHeader", label: "Header Title Text" }}
            formik={formik}
            col_md={12}
            col_lg={6}
            placeholder="Enter Title Text"
          />
          <FormField
            field={{ name: "subtitleHeader", label: "Header Content Text" }}
            formik={formik}
            required={false}
            col_md={12}
            col_lg={12}
            placeholder="Enter Header Content Text"
          />
          <FileUploadField
            name="ItemImgURL"
            label="Banner Image *"
            formik={formik}
            accept=".png,.jpg,.jpeg"
            col_md={6}
            col_lg={2}
          />
          <FileUploadField
            name="ItemVideo"
            label="Banner Video"
            formik={formik}
            accept="video/*"
            col_md={8}
            col_lg={2}
          />
          <div className={`col-md-6 col-lg-8`}>
            <label>Header Block Content</label>

            <div className="form-icon-group mb-4 mt-2">
              {checkboxOptions.map((checkbox) => (
                <div
                  className="custom-control custom-checkbox text-left mb-3 mr-3"
                  key={checkbox.name}
                >
                  <input
                    type="checkbox"
                    id={checkbox.name}
                    name={checkbox.name}
                    className={`custom-control-input ${formik.touched[checkbox.name] &&
                      formik.errors[checkbox.name] &&
                      "is-invalid"
                      }`}
                    checked={formik.values[checkbox.name] === 1}
                    onChange={(e) => {
                      formik.setFieldValue(
                        checkbox.name,
                        e.target.checked ? 1 : 0
                      );
                    }}
                  />
                  <label
                    htmlFor={checkbox.name}
                    className="custom-control-label"
                  >
                    {checkbox.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
          <div className="col-md-12">
            <hr
              className="border border-2"
              style={{ borderColor: "var(--border-color)" }}
            />
          </div>

          <div className="col-md-12">
            <div className="edit-icon new-card-header">
              <h4 className="card-header">Button Settings</h4>
            </div>
          </div>

          {buttonConfigs.map((buttonConfig, index) => (
            <HeaderButtonBlock
              key={buttonConfig.idx}
              buttonConfig={buttonConfig}
              formik={formik}
              headerButtonTypeArr={headerButtonTypeArr}
              isLast={index === buttonConfigs.length - 1}
            />
          ))}

          <div className="col-md-12">
            <hr
              className="border border-2"
              style={{ borderColor: "var(--border-color)" }}
            />
          </div>

          <div className="col-md-12">
            <div className="edit-icon new-card-header">
              <h4 className="card-header">Style Settings</h4>
            </div>
          </div>

          {
            formik.values?.isOverrideColor ?
              <>
                {[
                  { label: "Background Colour", name: "BackgroundColor", color: true, type: "color", },
                  { label: "Banner Accent Colour", name: "SliderColor", color: true, type: "color", },
                ].map((field, index) => (
                  <FormField key={index} field={field} formik={formik} />
                ))}
              </>
              :
              <>
                <FormField
                  field={{ name: "BackgroundColor", label: "Background Colour" }}
                  formik={formik}
                  selectOptions={colorArr}
                />
                <FormField
                  field={{ name: "SliderColor", label: "Banner Accent Colour" }}
                  formik={formik}
                  selectOptions={colorArr}
                />
              </>
          }

          <div className="col-md-6 col-lg-6 d-flex align-items-center">
            <label className="mb-0">
              Override Colour Variable <i className="fal fa-info-circle"></i>
            </label>
            <div className="toggle-switch ml-2">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={formik.values?.isOverrideColor === 1}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "isOverrideColor",
                      e.target.checked ? 1 : 0
                    )
                    formik.setFieldValue(
                      "BackgroundColor",
                      e.target.checked ? "#000000" : ""
                    )
                    formik.setFieldValue(
                      "SliderColor",
                      e.target.checked ? "#000000" : ""
                    )
                  }
                  }
                />
                <span className="slider slider-round"></span>
              </label>
            </div>
          </div>
          <div className="col-md-12 form-group form-group-save-cancel">
            <PermissionsGate scopes={[subTab === "create" ? 'wbslnheadersadd' : 'wbslnheadersedit']} RenderError={() => (
              <button className="btn btn-save btn-success" disabled>
                <i className="fal fa-save"></i> Save
              </button>
            )}>

              <button
                className="btn btn-save btn-success"
                disabled={formik.isSubmitting || !formik.dirty}
                type="submit"
                title="Save"
              >
                <i className="fal fa-save"></i> Save
              </button>
            </PermissionsGate>
            <button
              className="btn btn-close btn-danger"
              type="button"
              title="Cancel"
              disabled={formik.isSubmitting}
              onClick={() => {
                formik.handleReset()
                formik.resetForm()
                setRefresh(Date.now())
              }
              }
            >
              <i className="fal fa-times"></i>Cancel
            </button>
          </div>
        </div>
        {Object.keys(formik.errors).map((key) => {
          if (!formik.touched[key]) {
            return null;
          }

          return (
            <div className="invalid-feedback d-block" key={key}>
              {getFormikErrorMessage(formik.errors[key])}
            </div>
          );
        })}
      </form>

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignPagePopupBrandTemp"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered available-assessment-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title">
                <i className="fal fa-file"></i> Assign Page
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <AssignPagePopup headerData={headerData} formik={formik} id={subId} assignedPage={assignedPopupPages} assignedPageRef={assignedPageRef} setAssignedPage={setAssignedPopupPages} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignQualificationPopup"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered available-assessment-modal"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title">
                <i className="fal fa-file"></i> Assign Qualification
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <AssignQualificationPopup formik={formik} id={subId} assignedPage={assignedQualification} setAssignedPage={setAssignedQualification} assignedQualificationRef={assignedQualificationRef} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignPagePopupBrandTemp_2"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered available-assessment-modal" role="document">
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title"><i className="fal fa-file"></i> Assign Page (Button 2)</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <AssignPagePopup headerData={headerData2} formik={formik} id={subId} modalId="#assignPagePopupBrandTemp_2" assignedPage={assignedPopupPages2} assignedPageRef={assignedPageRef2} setAssignedPage={setAssignedPopupPages2} fieldName="assignedPage2" />
            </div>
          </div>
        </div>
      </div>

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignQualificationPopup_2"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered available-assessment-modal" role="document">
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title"><i className="fal fa-file"></i> Assign Qualification (Button 2)</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <AssignQualificationPopup formik={formik} id={subId} assignedPage={assignedQualification2} setAssignedPage={setAssignedQualification2} assignedQualificationRef={assignedQualificationRef2} />
            </div>
          </div>
        </div>
      </div>

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignPagePopupBrandTemp_3"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered available-assessment-modal" role="document">
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title"><i className="fal fa-file"></i> Assign Page (Button 3)</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <AssignPagePopup headerData={headerData3} formik={formik} id={subId} modalId="#assignPagePopupBrandTemp_3" assignedPage={assignedPopupPages3} assignedPageRef={assignedPageRef3} setAssignedPage={setAssignedPopupPages3} fieldName="assignedPage3" />
            </div>
          </div>
        </div>
      </div>

      <div
        className="topic-add-modal modal able_modal01 fade"
        id="assignQualificationPopup_3"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered available-assessment-modal" role="document">
          <div className="modal-content">
            <div className="modal-header modal-header-custom">
              <h5 className="modal-title"><i className="fal fa-file"></i> Assign Qualification (Button 3)</h5>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <AssignQualificationPopup formik={formik} id={subId} assignedPage={assignedQualification3} setAssignedPage={setAssignedQualification3} assignedQualificationRef={assignedQualificationRef3} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderInformation;
